import React from "react";
import { Outlet } from "react-router-dom";

const ProfileLayoutPage: React.FC = () => {
  return <Outlet />;
};

export default ProfileLayoutPage;

